import { SearchSortEnum } from '@iheartjane/dm-sdk';

export enum WizardBrandPreference {
  FeaturedPicks = 'featured picks',
  FreshDrops = 'fresh drops',
  SurpriseMe = 'surprise me',
  TopRated = 'top rated',
}

const BRAND_PREFERENCE_TO_SORT: Record<WizardBrandPreference, SearchSortEnum> =
  {
    [WizardBrandPreference.FeaturedPicks]: SearchSortEnum.Default,
    [WizardBrandPreference.FreshDrops]: SearchSortEnum.Recommendation,
    [WizardBrandPreference.SurpriseMe]: SearchSortEnum.Recommendation,
    [WizardBrandPreference.TopRated]: SearchSortEnum.Rating,
  };

/**
 * Maps a wizard brand preference selection to a sort strategy string.
 * Defaults to 'recommended' for unknown preferences.
 */
export function mapBrandPreferenceToSort(
  brandPreference: WizardBrandPreference
): SearchSortEnum {
  return (
    BRAND_PREFERENCE_TO_SORT[brandPreference] ?? SearchSortEnum.Recommendation
  );
}
